module.exports = __webpack_public_path__ + "img/portland-patent-logo.2d00aa24.svg";